





























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { getUserFullName } from '@/helpers/functions';
import { IProject, ICompanyType, IProjectLaborType, IUser } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';
const namespace = 'project';
const ns = { namespace };

@Component({
  methods: {
    getUserFullName,
  },
  components: {
    UIDatePicker: () => import('@/components/UI/DatePicker.vue'),
  },
})
export default class ProjectDetail extends BaseDetail<IProject> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IProject>;
  @State('entities', { namespace: 'companyType' }) companyTypes: ICompanyType[];
  @State('laborTypes', { namespace: 'labor' }) laborTypes: IProjectLaborType[];
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  @State('currentUser', { namespace: 'user' }) user: IUser;
  mounted() {
    this.setValue(this.entityPatch, 'creator_id', this.user.id);
    this.loadEntity();
  }
}
